import { useQueryContext } from 'modules/savedViewsIndex/context';
import styled from 'styled-components';
import { ListsEmptyState } from 'ui/illustrations';
import { body1, colors, spacing, subtitle1 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${pxToRem(349)};
`;

const Title = styled.p`
  ${subtitle1}
  margin-bottom: ${spacing.half};
  margin-top: ${spacing.threeQuarter};
`;

const Subtitle = styled.p`
  ${body1}
  color: ${colors.textSecondary};
`;

const Link = styled.a`
  color: ${colors.textLink};
  text-decoration: underline;
`;

export const TEXT = {
  noViewsTitle: 'No saved views yet',
  searchTitle: 'No saved views matched your search',
  searchSubtitle: 'Try a different search term.',
};

export const EmptyState = () => {
  const { searchTerm } = useQueryContext();
  return (
    <Wrapper data-test="empty-state">
      <ListsEmptyState />
      <Title>{searchTerm ? TEXT.searchTitle : TEXT.noViewsTitle}</Title>
      <Subtitle>
        {searchTerm ? (
          TEXT.searchSubtitle
        ) : (
          <>
            Create a saved view in <Link href="/messagingInsights">Messaging Insights</Link>.
          </>
        )}
      </Subtitle>
    </Wrapper>
  );
};
